export default __webpack_public_path__ + "static/media/old_gold_card_selected.413b9fb9.png";